<script>
	import { link } from 'svelte-routing';
	import GallerySlider from '../components/GallerySlider.svelte';
	import Reviews from '../components/Reviews.svelte';
	import { onMount, tick } from 'svelte';
	import { Navigation, Pagination, Autoplay, Scrollbar, A11y } from 'swiper';
	import { Swiper, SwiperSlide } from 'swiper/svelte';
	// Import Swiper styles
		import 'swiper/css';
		import 'swiper/css/navigation';
		import 'swiper/css/pagination';
		import 'swiper/css/scrollbar';
	onMount(() => {
		let items = document.querySelectorAll('.carouselR .carousel-itemR');
		items.forEach((el) => {
			const minPerSlide = 4
			let next = el.nextElementSibling
			for (var i=1; i<minPerSlide; i++) {
				if (!next) {
					// wrap carousel by using first child
					next = items[0]
				}
				let cloneChild = next.cloneNode(true)
				el.appendChild(cloneChild.children[0])
				next = next.nextElementSibling
			}
		})
	});
	let reviewsdata = [];
	const getReviews = async () => {
		let res = await fetch('https://www.mangomist.com/review_api.php');
		res = await res.json();
		reviewsdata = res.reviews;
		await tick();
		jQuery('.reviews-carousel').slick({
			slidesToShow: 4,
			autoplay: true,
			slidesToScroll: 1,
			variableWidth: true,
			arrows: true,
			fade: false,
			responsive: [
				{
				breakpoint: 1024,
				settings: {
					slidesToShow: 3,
					slidesToScroll: 3,
					infinite: true,
					variableWidth: false,
					dots: true
				}
				},
				{
				breakpoint: 600,
				settings: {
					slidesToShow: 2,
					variableWidth: false,
					slidesToScroll: 2
				}
				},
				{
				breakpoint: 480,
				settings: {
					slidesToShow: 1,
					variableWidth: true,
					slidesToScroll: 1
				}
				}
				// You can unslick at a given breakpoint now by adding:
				// settings: "unslick"
				// instead of a settings object
			]
		});
	}
	getReviews();
	const carouselImages = [
		{
			url: '/images/pool-1.jpg',
			title: 'EXOTIC POOLS',
		},
		{
			url: '/images/restaurant1-1.jpg',
			title: 'DINE WITH LOVED ONES',
		},
		{
			url: '/images/grill-1.jpg',
			title: 'GRILL UP SOME BBQ HAPPINESS',
		},
		{
			url: '/images/bar-1-1.jpg',
			title: 'AQUA BAR',
		},
		{
			url: '/images/room.jpg',
			title: 'COZY SPACES',
		},
		{
			url: '/images/lawn-1.jpg',
			title: 'TRUE PICNIC EXPERIENCE',
		},
		{
			url: '/images/camp-1.jpg',
			title: 'STARRY SKY CAMPING',
		},
		{
			url: '/images/restaurant2-1.jpg',
			title: 'GOOD FOOD, GOOD MOOD',
		},
		{
			url: '/images/room-1.jpg',
			title: 'LUXURY STAY',
		},
		{
			url: '/images/home_slider_1.jpg',
			title: 'LIFE&lsquo;s BETTER POOLSIDE'
		},
		{
			url: '/images/home_slider_2.jpg',
			title: 'COUNTRYSIDE LIVING'
		},
		{
			url: '/images/home_slider_3.jpg',
			title: 'DISCOVER YOUR TASTE'
		},
		{
			url: '/images/home_slider_4.jpg',
			title: 'Relax your soul'
		},
		{
			url: '/images/home_slider_3.jpg',
			title: 'A Tasty Journey'
		},
		{
			url: '/images/rsz_hall_2b.jpg',
			title: ''
		}
	]
	let presentTime = new Date().toLocaleTimeString();
</script>
<svelte:head>
	<script type="text/javascript" src="https://cdn.jsdelivr.net/npm/slick-carousel@1.8.1/slick/slick.min.js"></script>
	<style>
		@media only screen and (min-width: 320px) and (max-width: 600px) {
			body {
				/* overflow-x: hidden !important; */
			}
			.mangomist-room-carousel {
				overflow: hidden;
			}
		}
	</style>
</svelte:head>
<div id="home-page-carousel">
	<Swiper
		modules={[Navigation, Pagination, Autoplay, Scrollbar]}
		spaceBetween={0}
		slidesPerView={1}
		scrollbar
		autoplay
		navigation
		pagination={{ clickable: true }}
		on:slideChange={() => console.log('slide change')}
		on:swiper={(e) => console.log(e.detail[0])}
	>
	{#each carouselImages as item}
		<SwiperSlide>
			<div class=c-img>
				<img src={item.url} class="" alt={item.url}>
				{#if item.title}
					<h2 class="slider-title">
						{@html item.title}
					</h2>
				{/if}
			</div>
		</SwiperSlide>
		{/each}
	</Swiper>
</div>
<!-- <div id="home-page-carousel" class="carousel slide carousel-fade" data-bs-ride="carousel">
	<div class="carousel-indicators">
		{#each carouselImages as  item}
			<button type="button" data-bs-target="#home-page-carousel" data-bs-slide-to={item} class="active" aria-current="true" aria-label={item}></button>
		{/each}
	</div>
	<div class="carousel-inner">
		{#each carouselImages as item, i}
			<div class="carousel-item {i == 0 ? 'active' : ''}">
				<img src={item.url} class="d-block w-100" alt="...">
				{#if item.title}
					<h2 class="slider-title">
						{item.title}
					</h2>
				{/if}
			</div>
		{/each}
	</div>
	<button class="carousel-control-prev" type="button" data-bs-target="#home-page-carousel" data-bs-slide="prev">
	  <span class="carousel-control-prev-icon" aria-hidden="true"></span>
	  <span class="visually-hidden">Previous</span>
	</button>
	<button class="carousel-control-next" type="button" data-bs-target="#home-page-carousel" data-bs-slide="next">
	  <span class="carousel-control-next-icon" aria-hidden="true"></span>
	  <span class="visually-hidden">Next</span>
	</button>
</div> -->
<section class="main-top-section">
	<div class="home_block_box_bg">
		<div class="row">
			<div class="col-md-6">
				<h2 class="main-title">AROMAS OF NATURE !</h2>
				<div class="content-text">
					<p>
						Started in the year 2010 solely to revive one's golden memories of Indian childhood spent in the Mango fields amidst the early mist filled with mischief, joy, fear of unknown excitement , adventure and sweet aroma of the mangoes blended in the fragrance of the wet mud.Pass on these stories to their child, beloved ones, a friend or anyone who is yet to taste this sweet intoxication in their life.
					</p>
				</div>
				<!-- <div class="simple-weather inline-weather"><span>Thursday <i class="wi wi-day-sunny"></i> <em>27°C</em></span></div> -->
			</div>
			<div class="col-md-6">
				<h2 class="main-title color-green">GOING ECO !</h2>
				<div class="content-text">
					<p>
						Considering global warming at rise, we at mango mist  have taken steps to reduce the impact on our mother earth , upto 50% of energy consumed at mangomist is renewable solar energy including heat and electricity. 90% of the used water is recycled, treated and used for gardening. Also our chefs use organic vegetables and fruits sourced from local farmers and markets. We welcome you to experience an eco friendly holiday.
					</p>
				</div>
				<!-- <div class="calluna-time">
                    <span class="icon-clock" style="color: #967a50;"></span>
                    <span class="time" style="color: #0f2453;">
						{presentTime}
                    </span>
                </div> -->
			</div>
		</div>
	</div>
</section>
<section class="mangomist-room-carousel">
	<div class="row g-0 mangomist-slick-home-carousel">
		<div class="p-0">
			<div class="room-item">
				<a href="/mangomist-accomodation" use:link title="Accommodation" class="room-pic" target="_top">
					<img src="/images/Category-Cottsge1.jpg" alt="">
					<div class="room-content-wrapper">
						<span class="overlay"></span>
						<div class="room-title">
							<h3>Accommodation</h3>
						</div>
						<div class="room-excerpt">
							<p>Choose from a variety of cottages to stay overnight to experience the nature.</p>
						</div>
						<div class="room-price-wrapper">
							<div class="room-price style-2">
								<span>starting at</span>
								<span class="inline-price">₹ 5,990 </span>
							</div>
						</div>
					</div>
				</a>
			</div>
		</div>
		<div class=" p-0">
			<div class="room-item">
				<a href="/day-out-details" use:link title="Day-Out" class="room-pic" target="_top">
					<img src="/images/Category-Dayout2.jpg" alt="">
					<div class="room-content-wrapper">
						<span class="overlay"></span>
						<div class="room-title">
							<h3>Day-Out</h3>
						</div>
						<div class="room-excerpt">
							<p>A quick getaway to refresh yourself at the countryside.</p>
						</div>
						<div class="room-price-wrapper">
							<div class="room-price style-2">
								<span>starting at</span>
								<span class="inline-price">₹ 1,590 </span>
							</div>
						</div>
					</div>
				</a>
			</div>
		</div>
		<div class=" p-0">
			<div class="room-item">
				<a href="/camping-hut" use:link title="Camping" class="room-pic" target="_top">
					<img src="/images/Category-Tent2.jpg" alt="">
					<div class="room-content-wrapper">
						<span class="overlay"></span>
						<div class="room-title">
							<h3>Camping</h3>
						</div>
						<div class="room-excerpt">
							<p>Experience adventurous overnight stay in tents under the stars , along with great BBQ , warming yourself by the campfire.</p>
						</div>
						<div class="room-price-wrapper">
							<div class="room-price style-2">
								<span>starting at</span>
								<span class="inline-price">₹ 2,990 </span>
							</div>
						</div>
					</div>
				</a>
			</div>
		</div>
		<div class=" p-0">
			<div class="room-item">
				<a href="/cocktail-package" title="Cocktail Packages" class="room-pic" target="_top">
					<img src="/images/Clipboard01.jpg" alt="">
					<div class="room-content-wrapper">
						<span class="overlay"></span>
						<div class="room-title">
							<h3>Cocktail Packages</h3>
						</div>
						<div class="room-excerpt">
							<p>Relish Unlimited cocktails and BBQ for 90 min ending with dancing to the  music played by our Dj under the mist!</p>
						</div>
						<div class="room-price-wrapper">
							<div class="room-price style-2">
								<span>starting at</span>
								<span class="inline-price">₹ 2,590 </span>
							</div>
						</div>
					</div>
				</a>
			</div>
		</div>
	</div>
</section>
<section class="gallery-section">
	<div class="row g-0 w-100">
		<div class="col-12 col-md-4">
			<div class="left-box">
				<h2>
					Gallery
				</h2>
			</div>
		</div>
		<div class="col-12 col-md-8">
			<div class="g-box">
				<GallerySlider />
			</div>
		</div>
	</div>
</section>
<section class="gallery-section packages-box">
	<div class="row g-0 w-100">
		<div class="col-sm-8 col-sm-pull-4">
			<div class="g-box">
				<div class="my-slick">
					<!-- Temp removed -->
					<!-- <div class="slider-holder-box">
						<img class="slider-holder-img" src="/images/Clipboard03.jpg" alt="Clipboard03" />
						<div class="slider-content">
							<div class="row">
								<div class="col-sm-12 col-xs-12">
									<div class="offer_title"><h3><a href="/contact" use:link>COCKTAIL PACKAGE</a></h3></div>
								</div>
							</div>
							<div class="row">
								<div class="col-sm-12 item_text_wrapper">
									<div class="item_text">
										<p>
											Relish Unlimited cocktails and BBQ for 90 min ending with dancing to the music played by our Dj under the mist!
										</p>
										<div class="offer_price"><span>Price per group</span>₹ 17,500</div>
									</div>
								</div>
							</div>
						</div>
					</div> -->
					<div class="slider-holder-box">
						<img class="slider-holder-img" src="/images/Team-building-home-1.jpg" alt="Clipboard03" />
						<div class="slider-content">
							<div class="row">
								<div class="col-sm-12 col-xs-12">
									<div class="offer_title"><h3><a href="/contact" use:link>Corporate Team Building Package</a></h3></div>
								</div>
							</div>
							<div class="row">
								<div class="col-sm-12 item_text_wrapper">
									<div class="item_text"><p> “Alone we can do so little; together we can do so much.” - Helen Keller . Indulge in our designed team building activities for a great team bonding outing.</p>
										<div class="offer_price"><span>Price per group</span>₹ 15,000</div>
									</div>
								</div>
							</div>
						</div>
					</div>
					<div class="slider-holder-box">
						<img class="slider-holder-img" src="/images/Clipboard01-5.jpg" alt="Clipboard03" />
						<div class="slider-content">
							<div class="row">
								<div class="col-sm-12 col-xs-12">
									<div class="offer_title"><h3><a href="/contact" use:link>HONEYMOON / ANNIVERSARY PACKAGE</a></h3></div>
								</div>
							</div>
							<div class="row">
								<div class="col-sm-12 item_text_wrapper">
									<div class="item_text">
										<p>
											Designed to offer a memorable experience, With luxury stay and complimentary inclusions, we guarantee a romantic retreat for the couples.
										</p>
										<div class="offer_price"><span>Price per group</span>₹ 16,000</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
		<div class="col-sm-4 col-sm-push-8">
			<div class="left-box flex-column">
				<div class="content-box">
					<h4>
						SAFETY MATTERS
					</h4>
					<div class="home_offers_bg_color">
						<div class="gmail_default">
						<div dir="auto">
							<p dir="ltr">Dear guests,</p>
							<p dir="ltr">We at Mango mist resorts have introduced below strict safeguard operations to protect our guests and employees</p>
							<p dir="ltr"><strong>Limited bookings :</strong> Bookings are limited to control the number of guests.</p>
							<p dir="ltr"><strong>Going online :</strong> All payments, room service order, check in and check out are done online, please carry your mobile phones and chargers along.</p>
							<p dir="ltr"><strong>Hygiene + Restaurants :</strong> We are ISO 22000 certified, limited to 20 % occupancy, food served will be uv and heat treated, we are introducing an online menu and online ordering only, all cutlery and crockery are washed and dried using an automated german machine at 90°C.</p>
							<p dir="ltr"><strong>Hygiene + Cottages :</strong> All linen are washed with in-house industrial no human touch machines using 80°C hot water. Rooms are UV treated before check in. More frequent cleaning and disinfecting of high touch areas&nbsp; in our public spaces.</p>
							<p dir="ltr"><strong>Hygiene + sports :</strong> &nbsp;All sports and adventure equipment are sanitised and UV treated before every use. Enhanced social distancing and sanitisation measures introduced in public spaces.</p>
						</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</section>
<section style="max-height: 450px;">
	<div class="text-center">
		<div class="row mx-auto my-auto justify-content-center">
			<div id="recipeCarousel" class="carousel carouselR slide" data-bs-ride="carousel">
				<div class="carousel-inner" role="listbox">
					<div class="reviews-carousel">
						{#if reviewsdata && reviewsdata.length}
							{#each reviewsdata as item, i}
								{#if item}
								<Reviews reviewcode={item.booking_id} reviewrname={item.name} 
								reviewdate={item.date_created} description={item.positive} ratingnumber={item.overall_rating} />
								{/if}
							{/each}
						{/if}
					</div>
					<!-- <a class="carousel-control-prev bg-transparent w-aut" href="#recipeCarousel" role="button" data-bs-slide="prev">
						<span class="carousel-control-prev-icon" aria-hidden="true"></span>
					</a>
					<a class="carousel-control-next bg-transparent w-aut" href="#recipeCarousel" role="button" data-bs-slide="next">
						<span class="carousel-control-next-icon" aria-hidden="true"></span>
					</a> -->
				</div>
			</div>
		</div>
	</div>
</section>
<style>
	.main-top-section {
		background: url("../images/gpattern-opacity-1.png") repeat center;
		/*height: 400px;*/
		float: left;
		width: 100%;
		padding-left: 5px !important;
		padding-right: 5px !important;
		padding-top: 20px;
		padding-bottom: 20px;
	}
	.home_block_box_bg {
		-moz-border-bottom-colors: none;
		-moz-border-left-colors: none;
		-moz-border-right-colors: none;
		-moz-border-top-colors: none;
		background: rgba(130, 130, 130, 0.3) none repeat scroll 0 0;
		border-color: rgba(255, 255, 255, 0.4) rgba(60, 60, 60, 0.4) rgba(60, 60, 60, 0.4) rgba(255, 255, 255, 0.4);
		border-image: none;
		border-radius: 25px;
		box-shadow: 8px 8px 8px #888888;
		padding-top: 2% !important;
		padding-right: 2% !important;
		padding-bottom: 2% !important;
		padding-left: 2% !important;
	}
	.home_block_box_bg h2 {
		font-size: 3.125rem;
		font-weight: 500;
		line-height: 3.6rem;
		letter-spacing: .1em;
		padding-bottom: 60px;
		margin-bottom: 60px;
		position: relative;
	}
	.home_block_box_bg h2:after {
		border-bottom: 2px solid;
		border-color: inherit;
		bottom: -5px;
		content: "";
		left: 0;
		position: absolute;
		width: 100px;
	}
	.content-text p {
		font-size: 1.125rem;
		color: #444444;
		line-height: 2rem;
	}
	.mangomist-room-carousel {
		float: left;
		width: 100%;
	}
	.carousel-indicators [data-bs-target]{
		width: 14px;
		height: 14px;
		border-radius: 50%;
	}
	.main-title {
		font-size: 45px;
		color: #0f2453;
	}
	.color-green {
		color: #0b5345;
	}
	.room-item {
		position: relative;
	}
	.room-content-wrapper {
		position: absolute;
		height: 100%;
		width: 100%;
		top: 0;
		padding: 30px;
	}
	.overlay {
		position: absolute;
		top: 0;
		left: 0;
		right: 0;
		bottom: 0;
		background-color: rgba(15,36,83,.4);
		transition: all .3s ease;
	}
	.room-title {
		top: 40%;
		position: relative;
		text-align: center;
		display: block;
		transition: all .3s ease;
	}
	.room-excerpt {
		position: relative;
		top: 22%;
		opacity: 0;
		-webkit-transition: opacity .3s ease;
		-moz-transition: opacity .3s ease;
		-ms-transition: opacity .3s ease;
		-o-transition: opacity .3s ease;
		transition: opacity .3s ease;
	}
	.room-price-wrapper {
		position: absolute;
		bottom: 45px;
		text-align: center;
		left: 80px;
		right: 80px;
	}
	.room-item .room-excerpt {
		top: 0;
	}
	.room-item .room-content-wrapper:hover .room-excerpt {
		opacity: 1;
	}
	.room-item .room-content-wrapper:hover .room-title {
		top: 0;
	}
	.room-content-wrapper:hover .overlay {
		background-color: rgba(150,122,80,0.7);
	}
	.room-item img {
		width: 100%;
	}
	.room-title h3 {
		font-size: 2.125rem;
		line-height: 2.625rem;
		letter-spacing: .1em;
		font-weight: 400;
		color: #fff;
	}
	.room-excerpt p {
		color: #fff;
		text-align: justify;
	}
	.room-price {
		background-color: #967a50;
		color: #ffffff;
		letter-spacing: .1rem;
		padding: 14px 36px;
		text-transform: uppercase;
		font-family: Lato;
		font-weight: 500;
		font-size: 1.125rem;
		-webkit-transition: all .3s ease;
		-moz-transition: all .3s ease;
		-ms-transition: all .3s ease;
		-o-transition: all .3s ease;
		transition: all .3s ease;
		border-radius: 6px;
	}
	.gallery-section {
		min-height: 700px;
		clear: both;
		display: flex;
		width: 100%;
	}
	.left-box h2 {
		font-size: 3.125rem;
		text-transform: uppercase;
		font-weight: 500;
		line-height: 3.6rem;
		letter-spacing: .1em;
		padding-bottom: 60px;
		color: #967a50;
		position: relative;
	}	
	.left-box  h2:after {
		border-bottom: 2px solid;
		border-color: inherit;
		color: #967a50;
		bottom: 0;
		content: "";
		left: 0;
		position: absolute;
		width: 100px;
	}
	.gallery-section {
		background: #0f2453;
	}
	.left-box {
		background: url("../images/logo-back-ground.png") no-repeat center;
		height: 100%;
		padding-left: 12% !important;
		display: flex;
		align-items: center;
	}
	.g-box {
		padding: 10px 10px 10px 10px;
	}
	.content-box {
		color: #fff;
	}
	.content-box p {
		font-size: 1.125rem;
		color: #fff;
		line-height: 2rem;
	}
	.packages-box {
		background: #fff;
	}
	.packages-box .g-box {
		padding-top: 4% !important;
		height: 100%;
		padding-bottom: 4% !important;
		padding-left: 3% !important;
		background-position: 0 0 !important;
		background-repeat: no-repeat !important;
		background: url('../images/gpattern-opacity-1.png') no-repeat center;
	}
	.slider-holder-img {
		border-radius: 12px 12px 0 0;
	}
	.slider-content {
		padding: 0 15px;
	}
	.content-box h4 {
		color: #fff;
	}
	.packages-box .left-box {
		padding-top: 1% !important;
		padding-right: 8% !important;
		padding-bottom: 7% !important;
		padding-left: 6% !important;
		background: #0f2453 url("../images/logo-back-ground.png") !important;
		background-position: center !important;
		background-repeat: no-repeat !important;
		background-size: cover !important;
	}
	.slider-title {
		font-family: "Raleway";
		font-weight: 500;
		font-size: 76px;
		text-align: center;
		line-height: normal;
		color: #ffffff;
		text-transform: uppercase;
		letter-spacing: 10px;
		font-size: 5rem;
		position: absolute;
		top: 44%;
		left: 50%;
		transform: translate(-50%, -50%);
		padding: 0;
		margin: 0;
		text-decoration: none;
		width: 100%;
	}
	.slider-title:after {
		display: none;
	}
	.carousel-control-next, .carousel-control-prev {
		width: 6%;
	}
		@media (max-width: 767px) {
		.carousel-inner .carousel-itemR > div {
			display: none;
		}
		.carousel-inner .carousel-itemR > div:first-child {
			display: block;
		}
	}
	.carousel-inner .carousel-item.active,
	.carousel-inner .carousel-item-next,
	.carousel-inner .carousel-item-prev {
		display: flex;
	}
	/* medium and up screens */
	@media (min-width: 768px) {
		.carousel-inner .carousel-item-end.active,
		.carousel-inner .carousel-item-next {
		transform: translateX(25%);
		}
		.carousel-inner .carousel-item-start.active, 
		.carousel-inner .carousel-item-prev {
		transform: translateX(-25%);
		}
	}
	.carousel-inner .carousel-item-end,
	.carousel-inner .carousel-item-start { 
	transform: translateX(0);
	}
	#recipeCarousel {
		padding-left: 0;
		padding-right: 0;
	}
	.left-box p strong {
		font-weight: 700;
	}
	:global(.reviews-carousel .slick-prev) {
		position: absolute;
		background: url("../images/left-arrow.png") no-repeat !important;
		width: 40px;
		height: 40px;
		left: 20px;
		top: 50% !important;
		z-index: 99;
	}
	:global(.reviews-carousel) {
		position: relative;
	}
	:global(.reviews-carousel .slick-prev::before), :global(.reviews-carousel .slick-next::before) {
		font-size: 0;
	}
	:global(.reviews-carousel .slick-next) {
		position: absolute;
		background: url("../images/right-arrow.png") no-repeat !important;
		width: 40px;
		height: 40px;
		right: 20px;
		top: 50% !important;
		z-index: 99;
	}
	:global(.reviews-carousel .room-excerpt p) {
		display: -webkit-box;
		-webkit-line-clamp: 3;
		-webkit-box-orient: vertical;
		overflow: hidden;
	}
	:global(.mangomist-slick-home-carousel .slick-prev ) {
		display: block;
		position: absolute;
		left: 0;
		z-index: 9;
		width: 40px;
		top: 44%;
		height: 60px;
	}
	:global(.mangomist-slick-home-carousel .slick-prev::before) {
		font-size: 30px;
	}
	:global(.mangomist-slick-home-carousel .slick-next ) {
		display: block;
		position: absolute;
		right: 0;
		z-index: 9;
		width: 40px;
		top: 44%;
		height: 60px;
	}
	:global(.mangomist-slick-home-carousel .slick-next::before) {
		font-size: 30px;
	}
	.c-img {
		width: 100%;
		height: 1000px;
	}
	.c-img img {
		width: 100%;
		height: 100%;
	}

	:global(.swiper-button-next:after), :global(.swiper-button-prev:after) {
		display: none ;
	}

	:global(.swiper-button-next) {
		width: 36px !important;
		height: 24px !important;
		background-image: url("/images/right-arrow.png") !important;
	}

	:global(.swiper-button-prev) {
		width: 36px !important;
		height: 24px !important;
		background-image: url("/images/left-arrow.png") !important;
	}
	@media only screen and (min-width: 320px) and (max-width: 600px) {
		.slider-title {
			font-size: 13px;
		}
		#home-page-carousel .carousel-control-next, #home-page-carousel .carousel-control-prev {
			display: none;
		}

		:global(.swiper-button-next), :global(.swiper-button-prev) {
			display: none !important;
		}
		.room-price-wrapper {
			left: 68px;
			right: 68px;
		}
		:global(.home_reviews_min_ht) {
			min-height: 400px !important;
			background-size: contain !important;
			background-repeat: no-repeat !important;
		}
		.reviews-carousel .room-excerpt p {
			-webkit-line-clamp: 5;
		}
		:global(.home-carousel .room2-carousel .room-title) {
			left: 50%;
			transform: translateX(-59%);
		}
		:global(.home-carousel .room-excerpt) {
			left: 50%;
			transform: translateX(-61%);
			padding: 0 30px;
		}
		:global(.reviews-carousel .room-excerpt p) {
			-webkit-line-clamp: 6;
		}
		:global(.home-carousel .room-price-wrapper) {
			left: 50%;
			transform: translate(-70%) !important;
		}
		:global(.packages-box .g-box .slick-slide) {
			min-height: 500px;
			margin-bottom: 20px;
		}
		:global(.reviews-carousel .slick-prev) {
			top: 55% !important;
		}
		:global(.reviews-carousel .slick-next) {
			top: 55% !important;
		}

		.c-img {
			height: 340px;
		}
	}

	:global(.swiper-pagination-bullet) {
		width: 12px !important;
		height: 12px !important;
		display: inline-block;
		border-radius: 50%;
		background: #fff !important;
		opacity: 0.5 !important;
	}

	:global(.swiper-pagination-bullet-active) {
		background: #fff !important;
		opacity: 1 !important;
	}

	@media only screen and (min-width: 601px) and (max-width: 765px) {
		.slider-title {
			font-size: 18px;
		}

		.c-img {
			height: 430px;
		}
	}

	@media only screen and (min-width: 766px) and (max-width: 850px) {
		.c-img {
			height: 540px;
		}
	}
</style>